module.exports = __webpack_public_path__ + "img/event2.04eac019.png";